// For Visitor
import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'

import VueGtm from '@gtm-support/vue2-gtm'
const MyPage = () => import( '@/components/MyPage' )
const TentativeReservedPage = () => import( '@/components/TentativeReservedVisitor' )
const EventPasswordReset = () => import( '@/components/EventPasswordReset' )
const EventPasswordSetting = () => import( '@/components/EventPasswordSetting' )
const VisitorInvitation = () => import( '@/components/VisitorInvitation' )
const Publish = () => import( '@/components/Publish' )
const PublishBundleSite = () => import( '@/components/bundlesite/publish/Publish' )
const DoLandingSurveySite = () => import( "@/components/survey/DoLandingSurveySite" )
const DoLandingQuizSite = () => import( "@/components/quiz/DoLandingQuizSite" )
const Error = () => import( '@/components/Error' )
const SignUpError = () => import( '@/components/SignUpError' )

const PaymentSquare = () => import( '@/components/square/PaymentSquare' )
const PaymentSbpsNoTds = () => import( '@/components/sbps/PaymentSbpsNoTds' )
const PaymentSbps = () => import( '@/components/sbps/PaymentSbps' )

Vue.use(VueRouter)
Vue.use(Meta)

const router =  new VueRouter({
  mode: 'history',
  base: 'event',
  routes: [
    {
      path: '/:publishId/MyPage',
      name: 'MyPage',
      component: MyPage
    },
    {
      path: '/:publishId/TentativeReservedPage',
      name: 'TentativeReservedPage',
      component: TentativeReservedPage
    },
    {
      path: '/:publishId/PasswordReset',
      name: 'PasswordReset',
      component: EventPasswordReset
    },
    {
      path: '/:publishId/PasswordSetting',
      name: 'EventPasswordSetting',
      component: EventPasswordSetting
    },
    {
      path: '/VisitorInvitation',
      name: 'VisitorInvitation',
      component: VisitorInvitation
    },
    {
      path: '/Error',
      name: 'Error',
      component: Error
    },
    {
      path: '/:publishId/SignUpError',
      name: 'SignUpError',
      component: SignUpError
    },
    {
      path: '/:publishId',
      name: 'Publish',
      component: Publish
    },
    {
      path: '/:publishId/payment/square/:uuid',
      name: 'PaymentSquare',
      component: PaymentSquare
    },
    {
      path: '/:publishId/payment/sbps/nt/:uuid',
      name: 'PaymentSbpsNoTds',
      component: PaymentSbpsNoTds
    },
    {
      path: '/:publishId/payment/sbps/:uuid',
      name: 'PaymentSbps',
      component: PaymentSbps
    },
    {
      path: '/bundlesite/:publishId',
      name: 'PublishBundleSite',
      component: PublishBundleSite
    },
    {
      path: '/:eventPublishId/DoLandingSurveySite/:surveyPublishId',
      name: 'DoLandingSurveySite',
      component: DoLandingSurveySite
    },
    {
      path: '/:eventPublishId/DoLandingQuizSite/:quizPublishId',
      name: 'DoLandingQuizSite',
      component: DoLandingQuizSite
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }; // トップに移動
  }
})

import gtmCommon from '../mixins/gtmCommon'
import TentativeReservedVisitor from "@/components/TentativeReservedVisitor.vue";
Vue.mixin(gtmCommon)
let gtmIds = gtmCommon.methods.getEventSiteGtmIds()

export default router

Vue.use(VueGtm, {
  id: gtmIds.gtmId, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  queryParams: {
    // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
    gtm_auth: gtmIds.gtmAuth,
    gtm_preview: gtmIds.gtmPreview,
    gtm_cookies_win: 'x',
  },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  //ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  }
)
